import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

// Import Form
import { Row } from "react-bootstrap";

//import Moment JS
import moment from "moment";
import "moment/locale/th";
moment.locale("th");

// Import Modal
import Modal from "react-bootstrap/Modal";

//Import Accordion
import Accordion from "react-bootstrap/Accordion";

//Import service
// import academyService from "../../services/academy.service";
import farmermasterService from "services/farmermaster.service";
import farmerService from "../../services/farmer.service";
import uploadService from "../../services/uploadfile.service";
import apihostname from "../../services/apihostname";
// import UserService from "../../services/user.service";

//Import Loading
import LoadingAlert from "../../components/LoadingAlert";
import { toast } from "react-toastify";

function ModalViewMasterapprove(props) {
  const [assoc, setAssoc] = useState([]);
  const [farmer, setFarmer] = useState({});
  const [directsent, setDirectsent] = useState([]);
  const [undersent, setUndersent] = useState([]);
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [plant, setPlant] = useState([]);

  const getAssocMember = (master_id) => {
    farmermasterService.getMasterAssocMember(master_id).then((response) => {
      if (response.data.success) {
        setAssoc(response.data.data);
      }
    });
  };

  const getDirectSent = (master_id) => {
    farmermasterService.getMasterDirect(master_id).then((response) => {
      if (response.data.success) {
        setDirectsent(response.data.data);
      }
    });
  };

  const getUnderSent = (master_id) => {
    farmermasterService.getMasterUnder(master_id).then((response) => {
      if (response.data.success) {
        setUndersent(response.data.data);
      }
    });
  };

  const getMasterDeed = (master_id) => {
    farmermasterService.getMasterDeed(master_id).then((response) => {
      if (response.data.success) {
        setPlant(response.data.data);
      }
    });
  };

  const handleClose = () => {
    props.hidden(false);
  };

  const getFarmer = (farmer_idcard) => {
    farmerService.getFarmerById(farmer_idcard).then((response) => {
      setFarmer(response.data.farmer);
    });
  };

  const listfile = (masterid) => {
    setLoading(true);
    uploadService
      .listMasterfile(masterid)
      .then((response) => {
        setFiles(response.data.data);
      })
      .catch((err) => toast.error(err))
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (Object.keys(props.master_select).length != 0) {
      getAssocMember(props.master_select.masterid);
      getFarmer(props.master_select.masteridcard);
      getDirectSent(props.master_select.masterid);
      getUnderSent(props.master_select.masterid);
      getMasterDeed(props.master_select.masterid);
      listfile(props.master_select.masterid);
    }
  }, [props.master_select.masterid]);

  return (
    <>
      {loading ? <LoadingAlert /> : ""}
      <Modal size="xl" show={props.show} onHide={handleClose} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>อนุมัติจดทะเบียน หน.กลุ่ม</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Accordion defaultActiveKey="0" alwaysOpen>
            <Accordion.Item eventKey="0">
              <Accordion.Header>ข้อมูลพื้นฐาน</Accordion.Header>
              <Accordion.Body>
                <div className="farmer-profile-img">
                  <img
                    src={
                      process.env.REACT_APP_API +
                      "/images/farmer/" +
                      farmer.farmer_image
                    }
                    alt="No Image"
                    width="150"
                    height="150"
                  />
                </div>
                <br />
                <span>บัตรประชาชน : </span> {farmer.id_card}
                <br />
                <span>ชื่อ - นามสกุล : </span>{" "}
                {farmer.pre_name +
                  " " +
                  farmer.first_name +
                  " " +
                  farmer.last_name}
                <br />
                <span>ที่อยู่ : </span>{" "}
                {farmer.address +
                  " แขวง/ตำบล " +
                  farmer.tam_namt +
                  " เขต/อำเภอ " +
                  farmer.amp_namt +
                  " จังหวัด " +
                  farmer.prov_namt}
                <br />
                <span>เพศ : </span>
                {farmer.sex}
                <br />
                <span>วันเกิด : </span>
                {moment(farmer.birth_date)
                  .add(543, "year")
                  .locale("th")
                  .format("ll")}
                <br />
                <span>เบอร์โทร : </span>
                {farmer.tel}
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
              <Accordion.Header>ข้อมูลการเป็นสมาชิกสถาบัน</Accordion.Header>
              <Accordion.Body>
                {assoc.map((item, key) => {
                  return (
                    <li key={key} name={item.association_id}>
                      {item.association_name_th}
                    </li>
                  );
                })}
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="2">
              <Accordion.Header>ข้อมูลการส่งอ้อย</Accordion.Header>
              <Accordion.Body>
                <Row>
                  {directsent.map((item, key) => {
                    return (
                      <li
                        key={key}
                        className="cademy-ui"
                        name={item.factory_id}
                      >
                        {" ชื่อโรงงาน : " +
                          item.factory_name +
                          " ส่งอ้อย : " +
                          item.direct_sent +
                          " ตัน"}
                      </li>
                    );
                  })}
                </Row>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="3">
              <Accordion.Header>ข้อมูลลูกไร่</Accordion.Header>
              <Accordion.Body>
                <Row>
                  {undersent.map((item, key) => {
                    return (
                      <li
                        key={key}
                        className="cademy-ui"
                        name={item.under_idcard}
                      >
                        {item.under_idcard +
                          " ชื่อ - สกุล : " +
                          item.under_fullname +
                          " ส่งอ้อยจำนวน " +
                          item.under_sent +
                          " ตัน"}
                      </li>
                    );
                  })}
                </Row>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="4">
              <Accordion.Header>
                ข้อมูลที่ดิน(รวมพื้นที่ปลูกอ้อย{" "}
                {plant.reduce((total, item) => {
                  return total + parseInt(item.deed_rai);
                }, 0)}
                {" ไร่"})
              </Accordion.Header>
              <Accordion.Body>
                <Row>
                  {plant.map((item, key) => {
                    return (
                      <div key={key}>
                        <li className="cademy-ui" key={key} name={key}>
                          {" ประเภทที่ดิน : " +
                            item.deed_type +
                            " ประเภทเอกสาร : " +
                            item.deed_owner +
                            " เนื้อที่ : " +
                            item.deed_rai +
                            " ไร่"}
                        </li>
                      </div>
                    );
                  })}
                </Row>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="5">
              <Accordion.Header>Download เอกสาร</Accordion.Header>
              <Accordion.Body>
                {files.map((item, key) => {
                  return (
                    <li key={key}>
                      {item}
                      <a
                        href={
                          apihostname +
                          "/uploads/master/" +
                          props.master_select.masterid +
                          "/" +
                          item
                        }
                        download={item}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <button
                          className="btn btn-primary btn-sm"
                          style={{ padding: "0.3rem" }}
                        >
                          download
                        </button>
                      </a>
                    </li>
                  );
                })}
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    </>
  );
}

export default ModalViewMasterapprove;

ModalViewMasterapprove.propTypes = {
  show: PropTypes.bool,
  hidden: PropTypes.func,
  master_select: PropTypes.object,
  afterSubmit: PropTypes.func,
  // academy: PropTypes.array,
  // data: PropTypes.object,
  // setdata: PropTypes.func,
};

// ModalAddDetail.defaultProps = {
//   farmer_idcard: 0,
// };
